import { render, staticRenderFns } from "./news-results.vue?vue&type=template&id=c00e5a6a&"
import script from "./news-results.vue?vue&type=script&lang=js&"
export * from "./news-results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c00e5a6a', component.options)
    } else {
      api.reload('c00e5a6a', component.options)
    }
    module.hot.accept("./news-results.vue?vue&type=template&id=c00e5a6a&", function () {
      api.rerender('c00e5a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/news/news-results.vue"
export default component.exports